document.addEventListener("DOMContentLoaded", function () {
  // Select the auto part search bar element
  var autoPartSearchDiv = document.querySelector(".auto-part-search-bar");
  var websiteBody = document.querySelector("body");
  // Create a button for toggling the search bar
  var button = document.createElement("button");
  button.id = "apsToggleButton"; // Assign an ID to the button
  button.textContent = "FIND YOUR VEHICLE"; // Set button text
  button.classList.add("button"); // Add a CSS class to the button
  // Insert the button before the auto part search bar
  autoPartSearchDiv.parentNode.insertBefore(button, autoPartSearchDiv);

  // Add a click event listener to toggle the search bar's visibility
  button.addEventListener("click", function () {
    if (autoPartSearchDiv.classList.contains("open")) {
      autoPartSearchDiv.classList.remove("open"); // Close the search bar
      websiteBody.classList.remove("mmy-mobile-open");
    } else {
      autoPartSearchDiv.classList.add("open"); // Open the search bar
      websiteBody.classList.add("mmy-mobile-open");
    }
  });

  var labelDiv = document.createElement("div");
  labelDiv.classList.add("mmy-popuplabel");
  labelDiv.innerHTML = "Select Vehicle Year Make Model";  
  // Insert the label div before the auto part search bar
  autoPartSearchDiv.querySelector(".gv-mmy-bar").prepend(labelDiv);
  
  var closeButton = document.createElement("button");
  closeButton.id = "apsCloseButton"; // Assign an ID to the button
  closeButton.textContent = "X"; // Set button text
  closeButton.classList.add("button"); // Add a CSS class to the button

  // Insert the close button in the auto part search bar
  autoPartSearchDiv.querySelector(".gv-mmy-bar").prepend(closeButton);



  // Add a click event listener to close the search bar
  closeButton.addEventListener("click", function () {
    autoPartSearchDiv.classList.remove("open"); // Close the search bar
    websiteBody.classList.remove("mmy-mobile-open");
  });
});
